import { __decorate } from 'tslib';
import { Injectable, NgModule } from '@angular/core';
import { ApiService, ConfigOauthService, UiBsOauthModule } from '@wlp/ui-bs-oauth';

const SPE_N_OPEN_ACCOUNT = '/spe-n-open-account';
let SpeNOpenAccountProxy = class SpeNOpenAccountProxy {
    constructor(api) {
        this.api = api;
    }
    answerQuiz(body) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v1/data-mind/answer-quiz`;
        return this.api.post(uri, body);
    }
    checkOcr(body) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v1/check-fake-identity/documents?hasOcr=true`;
        return this.api.post(uri, body);
    }
    attPreAccount(id, data) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v1/pre-account/${id}/dynamic-fields`;
        return this.api.put(uri, data);
    }
    attPersonalData(id, data) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v1/personal-data/${id}`;
        return this.api.put(uri, data);
    }
    attAddressData(id, data) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v1/address-data/${id}`;
        return this.api.put(uri, data);
    }
};
SpeNOpenAccountProxy.ctorParameters = () => [
    { type: ApiService }
];
SpeNOpenAccountProxy = __decorate([
    Injectable()
], SpeNOpenAccountProxy);

let ConfigService = class ConfigService extends ConfigOauthService {
};
ConfigService = __decorate([
    Injectable()
], ConfigService);

const SPE_VIEW_N_OPEN_ACCOUNT = '/spe-view-n-open-account';
let SpeViewOpenAccountProxy = class SpeViewOpenAccountProxy {
    constructor(api) {
        this.api = api;
    }
    getCampaing(idDataFlow) {
        const uri = `${SPE_VIEW_N_OPEN_ACCOUNT}/v1/data-mind/campaign/${idDataFlow}`;
        return this.api.get(uri);
    }
    verifyAccountQuiz(body) {
        const uri = `${SPE_VIEW_N_OPEN_ACCOUNT}/v1/data-mind/flow`;
        return this.api.post(uri, body);
    }
};
SpeViewOpenAccountProxy.ctorParameters = () => [
    { type: ApiService }
];
SpeViewOpenAccountProxy = __decorate([
    Injectable()
], SpeViewOpenAccountProxy);

let UiPxQuizModule = class UiPxQuizModule {
};
UiPxQuizModule = __decorate([
    NgModule({
        declarations: [],
        imports: [
            UiBsOauthModule
        ],
        providers: [
            SpeNOpenAccountProxy,
            SpeViewOpenAccountProxy,
            ConfigService
        ]
    })
], UiPxQuizModule);

/*
 * Public API Surface of ui-bs-signup-proxy
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ConfigService, SpeNOpenAccountProxy, SpeViewOpenAccountProxy, UiPxQuizModule };
//# sourceMappingURL=wlp-ui-px-quiz.js.map
